import { useCallback } from "react";
import { toast as sonnerToast } from "sonner";

export const useToast = () => {
  const showToast = useCallback(
    ({ title, description, variant = "default", duration = 4000 }) => {
      const options = { duration };

      switch (variant) {
        case "destructive":
          return sonnerToast.error(description || title, {
            ...options,
            description: title,
          });
        case "success":
          return sonnerToast.success(description || title, {
            ...options,
            description: title,
          });
        default:
          return sonnerToast(description || title, {
            ...options,
            description: title,
          });
      }
    },
    []
  );

  return {
    toast: showToast,
    success: (message, options) =>
      showToast({ description: message, variant: "success", ...options }),
    error: (message, options) =>
      showToast({ description: message, variant: "destructive", ...options }),
    loading: (message, options) => sonnerToast.loading(message, options),
  };
};
